import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import AllotmentDetailView from './AllotmentDetailView';
import crmServices from '../../wsclient/crmservices'
import { getConditionContentByAllotment } from '../../utils/common';

const styles = theme => ({

});
const PAGE_SIZE = 20;
function AllotmentDetail(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [params, setParams] = useState(null);
    const [wallet_info, setWalletInfo] = useState(null);
    const [tab, setTab] = useState(0);
    const [transactions, setTransactions] = useState(null);
    const [transactionDetail, setTransactionDetail] = useState(null);
    const [showDetail, onShowDetail] = useState(false);
    const [paging, setPaging] = useState(null);
    const [hasMoreWalletTransactions, setHasMoreWalletTransactions] = useState(true);
    const [showLoadMoreWalletTransactions, onShowLoadMoreWalletTransactions] = useState(false);

    // useEffect(()=>{
    //     onLoadWalletInfo();
    // },[]);

    useEffect(() => {
        if (tab == 1) getWalletTransactions();
        else onLoadWalletInfo();
    }, [tab])

    const onLoadWalletInfo = async (isRefesh) => {
        onShowLoading(true);
        let wallet = props.wallet;
        let new_params = { ...params }
        new_params.walletId = wallet.id
        setParams(new_params);

        try {
            let result = await crmServices.account.getWaleltBalances({ ...new_params });
            //  console.log('getWaleltBalances== ',result)
            if (result.code == 'OK') {
                setWalletInfo(result.data)
            }
        } catch (error) {
            console.log("on load wallet info error:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async () => {
        onShowLoadMore(true);

        let new_params = { ...params }
        new_params.page = new_params.page + 1
        new_params.size = 10
        setParams(new_params);

        try {
            let result = await crmServices.account.getWaleltBalances({ ...new_params });
            // console.log('getWaleltBalances== ',result)
            if (result.code == 'OK') {
                setWalletInfo([...wallet_info, ...result.data])
                if (result.data.content.length === 0)
                    setHasMore(false);
            }
        } catch (error) {
            console.log("on load wallet info error:", error);
        }
        onShowLoadMore(false);
    }
    const createConditionContent = (allotments) => {
        let data = [];
        if (allotments.length == 0) {
            return data;
        }
        allotments.forEach(element => {
            let conditionText = getConditionContentByAllotment(element);
            element.conditionText = conditionText;
            data.push(element);
        });
        return data;
    }
    const getWalletTransactions = async () => {
        onShowLoading(true);
        try {
            let result = await crmServices.account.getWaleltJournal({
                size: PAGE_SIZE,
            });
            console.log("load wallet journal transactions:", result);
            if (result.code == 'OK') {
                setTransactions(result.data.content);
                setPaging(result.data.paging);
                if (result.data.paging && result.data.paging.size < 10) {
                    setHasMoreWalletTransactions(false);
                }
            }
        } catch (error) {
            console.log("load wallet journal transactions error:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMoreWalletTransactions = async () => {
        let page = paging.page + 1
        setPaging(prevState => ({
            ...prevState,
            page: page
        }));
        onShowLoadMoreWalletTransactions(true);
        try {
            let result = await crmServices.account.getWaleltJournal({ page: page, size: PAGE_SIZE });
            console.log('handleLoadMore transactions result=', result)
            if (result.code == 'OK') {
                setTransactions([...transactions, ...result.data.content]);
                if (result.data.paging && result.data.paging.size < PAGE_SIZE) {
                    setHasMoreWalletTransactions(false);
                }
            }
            onShowLoadMoreWalletTransactions(false);
        } catch (error) {
            console.log("load wallet journal transactions error:", error);
        }
    }
    const onClickDetail = (item) => {
        if (transactionDetail && transactionDetail.id && item.id === transactionDetail.id) {
            onShowDetail(!showDetail)
        }
        else {
            setTransactionDetail(item);
            onShowDetail(true);
        }
    }
    return (
        <div>
            <AllotmentDetailView
                showLoading={showLoading}
                tab={tab}
                open={props.open}
                wallet_info={createConditionContent(wallet_info && wallet_info.content ? wallet_info.content : [])}
                currency={props.currency}
                onCloseAllotment={props.onCloseAllotment}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                transactions={transactions}
                transactionDetail={transactionDetail}
                showDetail={showDetail}
                handleLoadMore={handleLoadMore}
                setTab={setTab}
                onClickDetail={onClickDetail}
                handleLoadMoreWalletTransactions={handleLoadMoreWalletTransactions}
            />
        </div>
    );
}


export default withStyles(styles)(withTranslation()(AllotmentDetail));